enum OrganizationErrorsCodes {}

export default OrganizationErrorsCodes;
